export const manageTeamMembersSuccessMessage = "Successfully removed contact from this service's notifications!";
export const removeTeamMemberTitle = 'Are you sure you want to remove this contact?';
export const removeButton = 'remove ';
